import React, {Fragment, PureComponent} from 'react';
import './index.scss';
import {connect} from 'react-redux';
import {
    getUserInfo,
} from './store/actionCreators';
import {Card, WingBlank, InputItem, Button, Toast, WhiteSpace} from 'antd-mobile';
import history from './../../utils/history';
import '../../utils/storage';
import {
    CreditCardTwoTone
} from '@ant-design/icons';

class MyCard extends PureComponent {

    constructor(props) {
        super(props);

    }

    componentDidMount() {
        let oauthInfo = Storage.Base.getInstance().get('_loginTk');
        if (!oauthInfo) {
            history.push('./login');
            return;
        }
        this.props.getUserInfo();
    }

    render() {
        const userInfo = this.props;
        console.log(userInfo.userInfo)
        const {cardNo, balance, venueName} = userInfo.userInfo;
        const title = "卡号:" + cardNo;
        return (
            <div>
                <WingBlank size="lg">
                    <WhiteSpace size="lg"/>
                    <Card onClick={() => {
                        history.push("/recharge");
                    }}
                          style={{background: "#009de2"}}
                    >
                        <Card.Header
                            title={<span style={{paddingLeft: "10px", color: "#FFFFFF"}}>{title}</span>}
                            thumb={<CreditCardTwoTone/>}
                            extra={<span style={{fontSize: "12px", color: "#FFFFFF"}}>会员卡</span>}
                        />
                        <Card.Body>
                            <div style={{textAlign: 'center', color: "#FFFFFF"}}>{venueName}</div>
                        </Card.Body>
                        <Card.Footer style={{textAlign: 'center', color: "#FFFFFF"}}
                                     content=""
                                     extra={<div style={{textAlign: 'center', color: "#FFFFFF"}}>
                                         余额: {balance / 100}元</div>}/>
                    </Card>
                    <WhiteSpace size="lg"/>
                </WingBlank>
            </div>
        )
    }
}


const mapStateToProps = (userInfo) => {
    return {
        userInfo: userInfo.userInfo.userInfo,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getUserInfo: (id) => dispatch(getUserInfo({userId: id})),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MyCard);
